import { memo } from 'react';
import { useTranslator, useUrlLocalizer } from 'tradera/lang/translate';
import { useSelector } from 'react-redux';
import { selectIsSwedishVisitor } from 'tradera/state/shipping-region/selectors';
import { selectIsForeignLanguageActivated } from 'tradera/state/language/selectors';
import { selectIsOutsideSweden } from 'tradera/state/member/selectors';
import { classNames } from 'tradera/utils/class-names';
import { Button } from 'tradera/components/atoms/button/button';

const SignUpLink = ({ clickAction, hasLoggedIn }) => {
    const { t } = useTranslator();
    const { toLocalizedUrl } = useUrlLocalizer();

    const register = t('siteHeader_register');

    const isForeignVisitor = useSelector(
        (state) =>
            (!selectIsSwedishVisitor(state) ||
                selectIsForeignLanguageActivated(state)) &&
            selectIsOutsideSweden(state),
    );
    const url = isForeignVisitor
        ? toLocalizedUrl('/register/foreign-private')
        : toLocalizedUrl('/register');

    const buttonClass = classNames('slim-header__button', {
        'd-none d-lg-flex': hasLoggedIn,
    });

    return (
        <Button
            theme={hasLoggedIn ? 'text' : 'highlight'}
            href={url}
            className={buttonClass}
            aria-label={register}
            title={register}
            onClick={clickAction}
            data-nav-signup
            data-ga-category="Top navigation"
            data-ga-action="Signup"
            data-ga-label="Link - Go to signup">
            <span className="slim-header__link-text">{register}</span>
        </Button>
    );
};

export default memo(SignUpLink);
